import { render, staticRenderFns } from "./xcxRegister.vue?vue&type=template&id=a435cb46&scoped=true&"
import script from "./xcxRegister.vue?vue&type=script&lang=js&"
export * from "./xcxRegister.vue?vue&type=script&lang=js&"
import style0 from "./xcxRegister.vue?vue&type=style&index=0&id=a435cb46&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a435cb46",
  null
  
)

component.options.__file = "xcxRegister.vue"
export default component.exports